const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.64588 27.5999C5.64588 27.5999 5.60375 27.6025 5.58332 27.6025C4.67436 27.6025 4.2186 28.1208 4.00413 28.8638C3.76795 29.6808 3.91476 30.563 4.35776 31.2894C4.54159 31.5894 4.73947 31.8933 4.89139 32.0758C4.20073 32.7524 3.33134 33.6946 3.33134 34.7376C3.33134 36.7968 5.00118 38.4654 7.05911 38.4654C8.36383 38.4654 9.51025 37.7951 10.1767 36.7815C10.6911 37.2066 11.3524 37.4632 12.0724 37.4632C12.4376 37.4632 12.7861 37.3968 13.1091 37.2768C13.7678 38.3288 14.9372 39.0296 16.27 39.0296C18.0739 39.0296 19.5778 37.7492 19.9237 36.0487C19.9493 36.0525 19.9748 36.0564 20.0003 36.0589C20.0003 36.0781 19.9991 36.0972 19.9991 36.1164C19.9991 38.21 21.6957 39.908 23.7907 39.908C25.5282 39.908 26.9912 38.7386 27.4393 37.1453C27.4865 37.1492 27.5338 37.1504 27.5823 37.1504C28.6623 37.1504 29.5496 36.3219 29.6415 35.2648C31.776 35.1538 33.4727 33.3882 33.4727 31.2269C33.4727 29.9055 32.8382 28.7323 31.8577 27.9944C32.5777 27.374 33.0348 26.4561 33.0348 25.4309C33.0348 23.6347 31.6356 22.1666 29.8687 22.0555C30.1228 21.4478 30.2479 20.7738 30.2083 20.0652C30.0832 17.8554 28.324 16.0438 26.1192 15.86C24.0613 15.6889 22.2651 16.9107 21.5668 18.6839C20.8365 17.1532 19.2739 16.0949 17.465 16.0949C15.3164 16.0949 13.5163 17.5873 13.044 19.5929C12.7542 19.4793 12.4376 19.4154 12.1069 19.4154C11.0856 19.4154 10.2035 20.0116 9.78983 20.8746C9.03151 19.9886 7.90807 19.4244 6.65187 19.4154C4.22882 19.4001 2.3611 21.4976 2.46451 23.9194C2.5526 26.0182 3.50113 27.5527 5.64588 27.5999Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7723 31.7056C14.0268 32.386 13.0591 32.7958 11.9995 32.7958C9.6479 32.7958 7.74316 30.7736 7.74316 28.2816C7.74316 25.7897 9.64918 23.77 11.9995 23.77C13.0591 23.77 14.0268 24.1798 14.7723 24.8603",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2637 32.7945C22.6158 32.7945 24.5226 30.774 24.5226 28.2816C24.5226 25.7892 22.6158 23.7687 20.2637 23.7687C17.9116 23.7687 16.0049 25.7892 16.0049 28.2816C16.0049 30.774 17.9116 32.7945 20.2637 32.7945Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9236 32.815L26.3563 32.815C26.1227 32.815 26.0027 32.5354 26.1635 32.3656L28.3121 30.1136C29.0717 29.3183 28.5674 27.9702 27.4695 27.9127C27.444 27.9114 27.4172 27.9102 27.3904 27.9102C26.544 27.9102 25.8584 28.6098 25.8584 29.4728",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6125 16.3413L30.6125 12.2203L33.4326 12.2203L31.007 8.01766L28.5801 3.81626L26.1545 8.01766L23.7289 12.2203L26.549 12.2203L26.549 13.608",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1067 13.5671L19.1067 9.64532L21.9268 9.64532L19.5012 5.44392L17.0743 1.24125L14.6487 5.44392L12.2218 9.64532L15.0432 9.64532L15.0432 13.5671",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60082 17.6012L7.60082 14.8373L10.4209 14.8373L7.99402 10.6347L5.56842 6.43198L3.14281 10.6347L0.715933 14.8373L3.53602 14.8373L3.53602 18.4081",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCo2);
export default __webpack_public_path__ + "static/media/icon-co2.5bd58bcb7c8b6893c741ee7af098c29e.svg";
export { ForwardRef as ReactComponent };